import React from 'react';
import { GameContext } from '../../../../contexts/game';
import { MediaCard } from './task-media/media-grid';

export const ProfilePhoto: React.FC = () => {
  const [game] = React.useContext(GameContext);

  const players = React.useMemo(() => {
    if (!game.gameState) return [];
    return game.gameState?.players;
  }, [game.gameState]);

  return (
    <div className={'d-flex flex-column flex-grow-1 w-100 overflow-auto'}>
      <div className={'reels-tasks-media-grid-container'}>
        {players.map((player) => (
          <MediaCard
            item={{
              id: player.code ?? '',
              url: player.avatarImage ?? '',
              type: 'image'
            }}>
            <div
              className={
                'd-flex align-items-center justify-content-center bg-white p-1 position-absolute'
              }
              style={{
                bottom: '8px',
                right: '8px',
                borderRadius: '4px',
                zIndex: 999,
                color: 'black'
              }}>
              {player.name}
            </div>
          </MediaCard>
        ))}
      </div>
    </div>
  );
};
